import { useEffect } from 'react';
import { useGetUserInfoQuery } from 'store/api/apiSlice';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { setSelectedProject as setSelectedProjectAction } from 'store/slices/projectSlice';
import { useApiError } from './useApiError';
import {
  deactivateHistoryMode,
  setActiveReport,
} from 'store/slices/historySlice';
import { Project } from 'store/api/apiTypes';

export const useSelectedProject = () => {
  const dispatch = useAppDispatch();
  const selectedProject = useAppSelector(
    state => state.project.selectedProject
  );
  const {
    data: userInfo,
    isLoading,
    error,
    refetch: refetchUserInfo,
    isFetching,
  } = useGetUserInfoQuery(undefined, {
    refetchOnMountOrArgChange: true, // Force fresh requests on mount
  });

  const {
    showErrorModal: showUserInfoErrorModal,
    handleApiError,
    handleRetry: handleUserInfoRetry,
    hideErrorModal: hideUserInfoErrorModal,
  } = useApiError(() => refetchUserInfo());

  // Handle API errors
  useEffect(() => {
    if (error) {
      handleApiError(error);
    }
  }, [error, handleApiError]);

  // Function to change project locally only (no API call)
  const setSelectedProject = (project: Project | null) => {
    dispatch(setSelectedProjectAction(project));
    dispatch(deactivateHistoryMode());
    dispatch(setActiveReport(undefined));
  };

  return {
    selectedProject,
    setSelectedProject,
    userInfo,
    isLoading,
    isFetching,
    error,
    refetchUserInfo,
    showUserInfoErrorModal,
    handleUserInfoRetry,
    hideUserInfoErrorModal,
  };
};
